import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Button from './Button';
import { isMobile } from '../services/DeviceInformation';
import mobileContentWidthCSS from '../constants/mobileContentWidthCSS';

const propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
};

const CancelButton = ({ label, onClick }) => (
    <Button
        css={({ blue }) => [
            css`
                display: flex;
                align-self: end;
                align-items: center;
                width: initial;
                min-width: 8.333rem;
                color: ${blue};

                &:not([disabled]):hover,
                &:not([disabled]):focus,
                &:not([disabled]):active {
                    color: ${blue};
                }
            `,
            isMobile() &&
                css`
                    ${mobileContentWidthCSS};
                    align-self: center;
                `,
        ]}
        variant="ghost"
        onClick={onClick}
    >
        {label}
    </Button>
);

CancelButton.propTypes = propTypes;
export default CancelButton;
